import { Page } from '@/core/architecture'

import { ArtistOfficialInformationTemplate } from './template'
import { useViewModel } from './viewModel'

/**
 * ArtistOfficialInformation Page
 * Implemented as a practical sample.
 */
export const ArtistOfficialInformation: Page = () => {
  const { state, actions } = useViewModel()

  return <ArtistOfficialInformationTemplate state={state} {...actions} />
}
